import StoreX from "../../../redux/oldStore";
import Icon, { IconType } from "../../Icon/Icon";

export function cockpitAppHref(fairId?: string) {
  const f = StoreX.GetQueryStringValue("f") || fairId;
  return f ? `/app/cockpit?f=${encodeURIComponent(f)}` : "/app/cockpit";
}

const CockpitSetupLink = (props: { lead: string; fairId?: string }) => {
  return (
    <div className="alert alert-info" data-testid="cockpit-setup-cta">
      <h4>
        <Icon type={IconType.checklist} /> Next step: Event Cockpit
      </h4>
      <p>{props.lead}</p>
      <a className="btn btn-primary" href={cockpitAppHref(props.fairId)} data-testid="cockpit-setup-link">
        Open Event Cockpit
      </a>
    </div>
  );
};

export default CockpitSetupLink;
